<!-- **** --------------------------------------------------------------------------
	SHARED SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts">
    import { onMounted, ref } from 'vue';

    // this is mostly for debugging, otherwise components are Anonymous
    export default {
        name: 'Container: Simple Grid',
    };
</script>

<!-- **** --------------------------------------------------------------------------
	SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            columns?: number;
            rows?: number;
            gap?: number;
            flow?: string;
            asp?: number;
            cellSize?: string;
        }>(),
        {
            columns: 0,
            rows: 0,
            gap: 0,
            asp: 1,
        }
    );

    const gridRef = ref();
    let autoCellSize = ref(0);
    onMounted(() => {
        //
        autoCellSize.value = (gridRef.value.offsetWidth - props.gap * (props.columns - 1)) / props.columns;
    });
</script>

<!-- **** --------------------------------------------------------------------------
	TEMPLATE
-------------------------------------------------------------------------- **** -->
<template>
    <div
        class="item-grid"
        ref="gridRef"
        :style="[
            columns ? `grid-template-columns: repeat(${columns}, var(--cell-size))` : '',
            rows ? `grid-template-rows: repeat(${rows * asp}, var(--cell-size))` : '',
            `--cell-size: ${cellSize || autoCellSize}px; --cell-asp: ${asp}`,
            {
                gap: `${gap}px`,
            },
        ]">
        <slot />
    </div>
</template>

<!-- **** --------------------------------------------------------------------------
	STYLES
-------------------------------------------------------------------------- **** -->
<style>
    .item-grid {
        --cell-size: auto;
        --cell-asp: 1;

        display: grid;
        position: relative;
        grid-auto-columns: var(--cell-size);
        grid-auto-rows: calc(var(--cell-size) * var(--cell-asp));
        height: 100%;
        width: 100%;
    }

    .item-cell {
        border-radius: 0.15rem;
    }
    .item-cell.mirage {
        background-color: var(--clr-mirage);
        background-color: hsl(0deg 0% 94%);
        box-shadow: inset 0 0 7px #00000014;
    }
</style>
